var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-drawer",
    {
      attrs: { size: _vm.size, visible: _vm.visible },
      on: { open: _vm.onOpen, close: _vm.onClose },
    },
    [
      _c(
        "ib-expand-panel",
        {
          attrs: {
            value: true,
            expandable: false,
            closable: "",
            color: "violet",
            inline: "",
            "close-btn-mobile-align": "",
          },
          on: { close: _vm.onClose },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "title-wrapper my-3 my-md-0" }, [
                    _c("div", { staticClass: "ai-buddy-drawer-title" }, [
                      _c("i", { staticClass: "icon ib-icon ib-icon-magic-2" }),
                      _c("div", { staticClass: "d-flex" }, [
                        _vm._v(" AI Buddy "),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "tabs" },
                      [
                        _vm.helpMeWrite && _vm.canEdit
                          ? _c(
                              "ib-button-tab",
                              {
                                staticClass: "my-3 my-md-0 button-tab",
                                attrs: {
                                  "is-active":
                                    _vm.activeComponent === "AiHelpMeWrite",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onClick("AiHelpMeWrite")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "font-outfit-medium" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("aiBuddy.helpMeWrite.title")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "ib-button-tab",
                          {
                            staticClass: "my-3 my-md-0 button-tab",
                            attrs: {
                              "is-active": _vm.activeComponent === "AiTips",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onClick("AiTips")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "font-outfit-medium" }, [
                              _vm._v(_vm._s(_vm.$t("tips"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.helpMeWrite
            ? _c("ai-help-me-write", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeComponent === "AiHelpMeWrite",
                    expression: "activeComponent === 'AiHelpMeWrite'",
                  },
                ],
                attrs: { type: _vm.type },
                on: {
                  close: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              })
            : _vm._e(),
          _vm.activeComponent === "AiTips"
            ? _c("ai-tips", {
                attrs: { type: _vm.type },
                on: {
                  close: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }